import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from '@salecycle/ui-component-library';
import { useWorkflowForm } from '../../../../../contexts/CampaignWorkflowFormContext';
import { useTrigger } from '../../hooks/useTrigger';
import { ConfigurationOption } from '../../../components/ConfigurationOption';
import { InfoTooltip } from 'sections/onsite-campaigns/pages/CampaignEditor/components/InfoTooltip';

export function InactivityConfiguration() {
  const { t } = useTranslation('campaigns');
  const { formDisabled } = useWorkflowForm();
  const { inactivity, setInactivity } = useTrigger();

  const onChange = useCallback((value: string) => setInactivity(parseInt(value)), [setInactivity]);

  return (
    <ConfigurationOption>
      <Input
        tooltipComponent={
          <InfoTooltip
            title={t('onsite.campaignInactivityDuration.tooltipTitle')}
            content={t('onsite.campaignInactivityDuration.tooltipContent')}
            displayInline
          />
        }
        disabled={formDisabled}
        type="number"
        min="0"
        label={t('onsite.campaignInactivityDuration.label')}
        ariaLabel={t('onsite.campaignInactivityDuration.label')}
        placeholder={t('onsite.campaignInactivityDuration.placeholder')}
        validationState={inactivity && 'complete'}
        value={inactivity || ''}
        onChange={onChange}
      />
    </ConfigurationOption>
  );
}
